import React from 'react';
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { SeasonRecordPoint } from './types';
import { OUTCOME, CHROME } from './dataViz';

interface Props {
  data: SeasonRecordPoint[];
}

const formatDate = (iso: string): string => {
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
};

const SeasonRecordChart: React.FC<Props> = ({ data }) => {
  if (data.length === 0) {
    return (
      <p className="text-sm text-gray-500 dark:text-gray-400 italic">No completed matches yet.</p>
    );
  }

  const chartData = data.map((point) => ({
    date: formatDate(point.date),
    Wins: point.cumulative_wins,
    Losses: point.cumulative_losses,
    opponent: point.opponent_name,
  }));

  return (
    <div className="h-64 w-full" data-testid="season-record-chart">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={CHROME.grid} />
          <XAxis dataKey="date" tick={{ fontSize: 12 }} />
          <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="Wins" stroke={OUTCOME.win} strokeWidth={2} dot={{ r: 3 }} />
          <Line
            type="monotone"
            dataKey="Losses"
            stroke={OUTCOME.loss}
            strokeWidth={2}
            dot={{ r: 3 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SeasonRecordChart;
